import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '@cuemath/comps';

import {
  ModalOverlay,
  ModalBox,
  ModalTitle,
  ModalText,
  ModalActions,
  ModalCancelButton,
} from '../tabs/dispositions/styled-comps';

const StyledButton = styled(Button)`
  && {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(56.99deg, #0177ff 0%, #1f48d7 100%);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: auto;
    transition: opacity 0.15s ease;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }
  &&:hover {
    opacity: 0.9;
    border: none;
  }
  &&:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ConfirmPublishButton = styled(Button)`
  && {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(56.99deg, #0177ff 0%, #1f48d7 100%);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: auto;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }
  &&:hover {
    opacity: 0.9;
    border: none;
  }
`;

function PublishButton({ onPublish, disabled, label = 'Publish' }) {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleConfirm = () => {
    setShowConfirm(false);
    onPublish();
  };

  return (
    <>
      <StyledButton
        label={label}
        onClick={() => setShowConfirm(true)}
        disabled={disabled}
      />
      {showConfirm && (
        <ModalOverlay onClick={() => setShowConfirm(false)}>
          <ModalBox onClick={e => e.stopPropagation()}>
            <ModalTitle>Confirm Publish</ModalTitle>
            <ModalText>
              Are you sure you want to publish? This will make the changes live.
            </ModalText>
            <ModalActions>
              <ModalCancelButton label="Cancel" onClick={() => setShowConfirm(false)} />
              <ConfirmPublishButton label="Publish" onClick={handleConfirm} />
            </ModalActions>
          </ModalBox>
        </ModalOverlay>
      )}
    </>
  );
}

export default PublishButton;
